module.exports = __webpack_public_path__ + "media/ptt_alert.6359ab27.wav";